import styled from 'styled-components';

import Button from '../../Button';

export const StyledInput = styled.input`
  width: 100%;
  height: 45px;
  padding: 0 17px;

  border-radius: 8px;
  border-width: thin;
  border-style: solid;
  border-color: ${({ theme }) => theme.palette.common.BACKGROUND_3};
  background-color: ${({ theme }) => theme.palette.common.WHITE};
  box-shadow: none;
  outline: none;

  transition: border 200ms ease 0s;

  &:disabled {
    cursor: not-allowed;
  }

  &:required {
    border: 1px solid ${({ theme }) => theme.palette.error};
  }
`;

export const HideTextButton = styled(Button).attrs(() => ({
  tabIndex: -1,
}))`
  position: absolute;
  bottom: 1px;
  color: ${({ theme }) => theme.palette.common.TEXTS};
  transition-property: right;
  transition-duration: 0.3s;

  span {
    font-size: 20px;
  }
`;
